module.exports = __webpack_public_path__ + "img/postback.177e3b78.gif";